import type { IconProps } from "./Icons";

export const IconSignaturePencil = ({
  width = 32,
  height = 32,
  color = "#fff",
}: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    viewBox="0 0 32 32"
  >
    <path
      className="signature-pencil-mark"
      fill={color}
      d="M19.234 4.435a3.911 3.911 0 0 1 5.532 5.531L22.73 12l.138.138a3.2 3.2 0 0 1 0 4.525l-2.303 2.303a.8.8 0 1 1-1.132-1.131l2.303-2.303a1.6 1.6 0 0 0 0-2.263l-.137-.137-10.634 10.634a.8.8 0 0 1-.372.21l-6.4 1.6a.8.8 0 0 1-.953-1.029l2-6a.8.8 0 0 1 .193-.312l13.8-13.8Zm4.4 1.131a2.311 2.311 0 0 0-3.268 0L6.699 19.233 5.22 23.67l4.772-1.193L23.634 8.835a2.311 2.311 0 0 0 0-3.269Z"
    />
    <path
      className="signature-written-mark"
      fill={color}
      d="M5.147 26.987l.082.06c1.188.865 2.95 1.753 5.17 1.753 1.19 0 2.278-.416 3.246-.967.965-.55 1.862-1.264 2.659-1.912l.187-.152c.742-.604 1.378-1.121 1.965-1.467.645-.38 1.03-.43 1.29-.343.425.142.667.469 1.087 1.871.14.467.39.977.754 1.387.366.411.91.784 1.612.784.76 0 1.51-.366 2.089-.707.382-.226.792-.508 1.125-.736.163-.113.308-.213.422-.286a7.37 7.37 0 0 1 1.037-.567c.124-.054.219-.09.28-.112l.063-.022.01-.003a.8.8 0 0 0-.45-1.535h-.002l-.004.002-.011.003-.035.01a6.078 6.078 0 0 0-.494.191c-.318.14-.756.36-1.265.69-.188.122-.367.246-.548.37-.296.205-.596.413-.94.616-.547.323-.978.486-1.277.486-.097 0-.24-.048-.417-.247-.178-.2-.329-.49-.416-.783-.384-1.282-.8-2.491-2.114-2.93-.94-.313-1.854.038-2.609.483-.697.41-1.428 1.006-2.14 1.586l-.208.17c-.803.652-1.606 1.287-2.441 1.763-.832.473-1.643.757-2.455.757a6.85 6.85 0 0 1-3.094-.752l-2.158.54Zm22.852-2.186a51.008 51.008 0 0 0-.224-.768L28 24.8Z"
    />
  </svg>
);
